export default "__VITE_ASSET__56265452__"